export default __webpack_public_path__ + "81b7346a0c7e0b1251c3656fc89f0678.gif";